import { useContext, useEffect, useState } from 'react';
import useSessionStorage from '../../hooks/useSessionStorage.js';
import { AssessmentContext } from '../../context/AssessmentContext.js';
import { showCustomDialog } from '../../scripts/learnosityScripts.js';
import CustomDialog from '../ui/feedback/CustomDialog.js';
import * as Storage from '../common/Storage.js';
import parse from 'html-react-parser';
import { Typography } from '@mui/material';
import { getSecondsAsMinAndSecString } from '../../scripts/common/helper.js';
import * as TestStatus from '../assessment/TestStatus.js';

const TimedAutoExitDialog = ({
  open,
  runBackground = false,
  onComplete,
  dialogDetails,
  actions,
  duration,
  storageKey = Storage.STORAGE_AUTO_EXIT_SECONDS,
}) => {
  //name of session storage variable
  const { getStorageItem, setStorageItem } = useSessionStorage();
  const { learnosityItemApp } = useContext(AssessmentContext);

  //Get auto exit seconds from session storage and update useState
  const [timeDurationSeconds, setTimeDurationSeconds] = useState();

  const getDialogContentAsComponent = (countdownSeconds) => {
    const newContent = dialogDetails.body.replace(
      '$COUNTDOWN_SECONDS_PLACEHOLDER',
      `<span id="custom_dialog_countdown" style="display:none">${countdownSeconds}</span><b id="custom_dialog_countdown_text">${getSecondsAsMinAndSecString(
        countdownSeconds
      )}</b>`
    );
    return <Typography>{parse(newContent)}</Typography>;
  };

  useEffect(() => {
    if (open && !runBackground) {
      const __savedAutoExitSeconds = getStorageItem(storageKey) || 0;
      var currentCount =
        __savedAutoExitSeconds > 0 && __savedAutoExitSeconds < duration
          ? __savedAutoExitSeconds
          : duration;
      setTimeDurationSeconds(currentCount);
      var countdownElem = document.getElementById('custom_dialog_countdown');
      var countdownElemText = document.getElementById(
        'custom_dialog_countdown_text'
      );
      //Create an interval for the requested duration
      let intervalId = setInterval(() => {
        currentCount--;
        //update session storage
        setStorageItem(storageKey, currentCount);

        if (currentCount <= 0) {
          clearInterval(intervalId);
          intervalId = null;
          onComplete();
          return;
        }
        if (!countdownElem || !countdownElemText) {
          countdownElem = document.getElementById('custom_dialog_countdown');
          countdownElemText = document.getElementById(
            'custom_dialog_countdown_text'
          );
        }
        countdownElem.innerHTML = currentCount;
        countdownElemText.innerHTML = getSecondsAsMinAndSecString(currentCount);
      }, 1000);

      return () => {
        clearInterval(intervalId);
        intervalId = null;
        setTimeDurationSeconds();
      };
    }
  }, [
    duration,
    onComplete,
    open,
    getStorageItem,
    setStorageItem,
    storageKey,
    runBackground,
  ]);

  return (
    <>
      {open && !runBackground && (
        <CustomDialog
          open={open}
          dialogProps={{
            title: dialogDetails.header,
            component: getDialogContentAsComponent(timeDurationSeconds),
            showWaiting: true,
            actions: actions,
          }}
        />
      )}
      {open &&
        !runBackground &&
        learnosityItemApp &&
        showCustomDialog(
          learnosityItemApp,
          dialogDetails,
          getStorageItem(Storage.STORAGE_TEST_STATUS) ===
            TestStatus.TEST_PAUSED,
        )}
    </>
  );
};

export default TimedAutoExitDialog;
